var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAchivement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 32 32",
    id: "OBJECT",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#FAB353;}")), /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("path", {
    d: "M8,14H6A5,5,0,0,1,1,9V5A1,1,0,0,1,2,4H8V6H3V9a3,3,0,0,0,3,3H8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,14H24V12h2a3,3,0,0,0,3-3V6H24V4h6a1,1,0,0,1,1,1V9A5,5,0,0,1,26,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,17.88A1,1,0,0,0,18,17H14a1,1,0,0,0-1,.88l-1,8a1,1,0,0,0,.24.78A1,1,0,0,0,13,27h6a1,1,0,0,0,.75-.34,1,1,0,0,0,.24-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,1H8A1,1,0,0,0,7,2V13a.94.94,0,0,0,.07.37l1.5,3.74A3,3,0,0,0,11.35,19h9.3a3,3,0,0,0,2.78-1.89l1.5-3.74A.94.94,0,0,0,25,13V2A1,1,0,0,0,24,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22,25H10a3,3,0,0,0-3,3v2a1,1,0,0,0,1,1H24a1,1,0,0,0,1-1V28A3,3,0,0,0,22,25Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchivement);
export default __webpack_public_path__ + "static/media/achivement.43bf80cbf52d376fbf3d92bdce72da88.svg";
export { ForwardRef as ReactComponent };